import { VariaveisAmbiente } from "config";
import { useApiBase } from "data/api/base";
import { TransferenciaGetModel } from "model/api/gestao/transferencia/transferencia-get-model";
import { useCallback } from "react";
import { useSessaoAtual } from "services/app";

export function useGetTransferenciaById() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<TransferenciaGetModel>();

    const { getEmpresa } = useSessaoAtual();

    const getTransferenciaById = useCallback(
        (id: string) =>
            invocarApi({
                method: 'GET',
                url: `/${VariaveisAmbiente.apiVersion}/Empresa/${getEmpresa().Id}/Transferencia/${id}`,
                headers: { 'Content-Type': 'application/json;charset=utf-8' },
                enviarTokenUsuario: true
            }),
        [getEmpresa, invocarApi]
    )

    return {
        ...outrasPropriedades,
        getTransferenciaById
    }
}